import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';

/**
 * Keyword Count with Paid Traffic
 */
const AtlasV2PaidTrafficProductsSplineChart = () => {
  return (
    <AtlasV2ComparableSplineChart
      indexName="traffic"
      fieldName="searchTerm"
      title="Keyword Count with Paid Traffic"
      requestBuilder={(builder) => builder.addConditionRangeFilter('adClicks', 1)}
    />
  );
};

export default AtlasV2PaidTrafficProductsSplineChart;
